import { Routes, Route, Navigate } from "react-router-dom";
import React, { useEffect, useContext, useState, Suspense } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Home from "../pages/home";
import Borrower from "../pages/borrower";
import Users from "../pages/users";
import Borrowers from "../pages/borrowers";
import { UserOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { AppContext } from "../context/AppContext";
import AddLoan from "../pages/forms/addLoan";
import EditLoan from "../pages/forms/editLoan";
import { Link } from "react-router-dom";
import AddGovtLoan from "../pages/forms/addGovtLoan";
import CollateralRegister from "../pages/collateralRegister";
import LoansPage from "../pages/loanPage";
import LoansDisbursedPage from "../pages/LoansDisbursedPage";
import LoansOutstandingPage from "../pages/LoansOutstandingPage";
import LoanDetailsPage from "../pages/loanDetails";
import LoanPortfolioSummary from "../pages/loanPorfolioSummary";
import AddBorrower from "../pages/forms/addBorrower";
import LoanProductsPage from "../pages/loanProducts";
import DelinquencyReport from "../pages/deliquencyReport";
import TransactionsPage from "../pages/transactionsPage";
import DocumentsPage from "../pages/documentsPage";
import FloatManagementPage from "../pages/floatManagementPage";
import AccountsManagement from "../pages/accountsManagement";
import RiskConcentrationReport from "../pages/riskConcentrationReport";
import PtpPage from "../pages/ptpPage";
import CashFlowForecast from "../pages/cashFlowForcast";
import ProfitabilityAnalysis from "../pages/profitabilityAnalysis";
import ApplicationPipelineReport from "../pages/applicationPipeline";
import CollateralReport from "../pages/collateralReport";
import CollateralProfile from "../pages/collateralProfile";
import BulkSMSPage from "../pages/bulksmsPage";
import WhatsAppPage from "../pages/whatsappPage";
import Billing from "../pages/billing";
import ContactToUpgrade from "../pages/contactToUpgrade";
import PlanCheckout from "../pages/planCheckout";
import Investors from "../pages/investors";
import InvestmentDetailsPage from "../pages/investmentDetailsPage";
import MaturityScheduleReport from "./maturityScheduleReport";
import InvestmentsPage from "../pages/investmentsPage";
import InvestmentProducts from "../pages/investmentProducts";
import BorrowerProfile from "../pages/borrowerProfile";
import ProfilePage from "../pages/ProfilePage";
import IssuesPage from "../pages/issuesPage";
import { Button, Grid } from "antd";
import Giftcards from "../pages/giftcards";
import GpsTrackers from "../pages/gpsTrackers";
import LoanOfficerPerformanceReport from "../pages/loanOfficerPerformance";
import axios from "axios";
import Branches from "../pages/branches";
import Commodities from "../pages/commodities";
import InvoicesPage from "../pages/invoicesPage";
import UpdateLoanStatus from "../pages/forms/updateLoanStatus";
import NrcVerificationPage from "../pages/nrcVerificationPage";
import BoardingHouses from "../pages/boardingHouses";
import DemoBookings from "../pages/demoBookings";
import DueTodayDashboard from "../components/DueTodayDashboard";
import RoleManagement from "../pages/roleManagement";
import CollateralSales from "../pages/collateralSales";
import DiscussionForum from "../pages/discussionForum";
import CalendarPage from "../pages/calendar";
import VehicleVerification from "../pages/vehicleVerification";
import RiderTracking from "../pages/riderTracking";
import ExpenseApprovalsPage from "../pages/expenseApprovalsPage";
import TestPDFGeneration from "../pages/testPDFGeneration";
import BusinessQuotationPage from "../pages/businessQuotationPage";
import TodaySummary from "../pages/todaySummary";
import DebtAgeAnalysis from "../pages/debtAgeAnalysis";
import DeliveriesPage from "../pages/deliveries";
import AccountStatement from "../pages/accountStatement";
import TrialBalance from "../pages/trialBalance";
import DoubleEntryBalanceSheet from "../pages/doubleEntryBalanceSheet";
import GeneralLedger from "../pages/generalLedger";
import IncomeStatement from "../pages/incomeStatement";
import AccountingMigration from "../pages/accountingMigration";
import AssetsManagement from "../pages/assetsManagement";
import JutemLoansPage from "../pages/jutemLoansPage";
import JutemExpensesPage from "../pages/jutemExpensesPage";
import JutemInvestmentsPage from "../pages/jutemInvestmentsPage";
import JutemInterestExpensesPage from "../pages/jutemInterestExpensesPage";
import JutemIncomeStatement from "../pages/jutemIncomeStatement";
import JutemEtlUploadPage from "../pages/jutemEtlUploadPage";
import JutemLedgerPage from "../pages/jutemLedgerPage";

const Content = ({ hideSidebar, topNav }) => {
  const { user, company } = useContext(AppContext);
  const [searchNrc, setSearchNrc] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const currentLocation = useLocation();
  const currentRoute = currentLocation.pathname;
  const navigate = useNavigate();

  const handleNrcSearch = async (e) => {
    e.preventDefault();
    if (!searchNrc.trim()) return;

    try {
      // Checking what API endpoints we have from borrowers.jsx
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `https://zedlenders.pickmesms.com/users?fields=*.*&filter[role][name][_eq]=Borrower&filter[nrc][_contains]=${encodeURIComponent(
          searchNrc.trim(),
        )}&filter[company]=${company.id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      console.log("Search response:", response.data.data);

      if (response.data.data.length > 0) {
        const borrower = response.data.data[0];
        navigate(`/borrower/${borrower.id}`);
      } else {
        // Try another search with exact match
        const exactResponse = await axios.get(
          `https://zedlenders.pickmesms.com/users?fields=*.*&filter[role][name][_eq]=Borrower&filter[nrc][_eq]=${encodeURIComponent(
            searchNrc.trim(),
          )}&filter[company]=${company.id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );

        if (exactResponse.data.data.length > 0) {
          const borrower = exactResponse.data.data[0];
          navigate(`/borrower/${borrower.id}`);
        } else {
          alert("No borrower found with that NRC number");
          console.log("No borrower found with that NRC");
        }
      }
    } catch (error) {
      console.error("Error searching for borrower:", error);
      alert("Error searching for borrower. Please try again.");
    }
  };

  return (
    <div
      className="content-wrapper"
      style={hideSidebar || topNav ? { marginLeft: 0 } : {}}
    >
      {/* {currentRoute !== "/" && (
        <div
          style={{
            padding: "16px 24px",
            borderBottom: "1px solid #f0f0f0",
          }}
        >
          <Button
            type="text"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate(-1)}
            style={{
              paddingLeft: 8,
              fontWeight: 500,
              color: "#1890ff",
              fontSize: "15px",
            }}
          >
            Back
          </Button>
        </div>
      )} */}
      <div
        style={{
          marginTop: "13px",
          backgroundImage: `
         radial-gradient(rgba(0, 0, 0, 0.2) 1px, transparent 1px),
          radial-gradient(rgba(0, 0, 0, 0.2) 1px, transparent 1px)
      `,
          backgroundPosition: "0 0, 25px 25px", // Adjust spacing between dots
          backgroundSize: "50px 50px", // Adjust size of the grid
          padding: "0 10px",
        }}
        className="container-fluid searchBar"
      >
        {!hideSidebar && (
          <form id="searchForm" onSubmit={handleNrcSearch}>
            <div className="responsive-search-container">
              <div
                className="input-group responsive-search-input"
                style={{
                  width: isMobile ? "100%" : "50%",
                  maxWidth: isMobile ? "100%" : "400px",
                }}
              >
                <div className="input-group-btn">
                  <button
                    type="button"
                    className="btn btn-success dropdown-toggle"
                    name="category"
                    id="category"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    value="Borrowers"
                  >
                    + New <span className="caret" />
                  </button>
                  <ul className="dropdown-menu">
                    <li>
                      <Link to={"/addBorrower"} className="category">
                        Borrower
                      </Link>
                    </li>

                    <li>
                      <Link to={"/addLoan"} className="category">
                        Loan (Custom)
                      </Link>
                    </li>
                    <li>
                      <Link to={"/addGovtLoan"} className="category">
                        Loan (Govt Employees)
                      </Link>
                    </li>
                    <li>
                      <Link
                        to={"/floatManagement?type=Operational%20Cost"}
                        className="category"
                      >
                        New Expense
                      </Link>
                    </li>
                    {/* <li>
                    <Link to={"/addInvestment"} className="category">
                      Investment
                    </Link>
                  </li> */}
                  </ul>
                </div>

                <input
                  type="text"
                  className="form-control"
                  name="search"
                  id="search"
                  placeholder={isMobile ? "Find by ID" : "Find by ID"}
                  value={searchNrc}
                  onChange={(e) => setSearchNrc(e.target.value)}
                  style={{
                    fontSize: isMobile ? "14px" : "16px",
                    padding: isMobile ? "8px 12px" : "10px 15px",
                  }}
                />
                <div className="input-group-btn">
                  <button
                    type="submit"
                    className="btn btn-default"
                    id="searchSubmit"
                  >
                    <i className="fa fa-search" aria-hidden="true" />
                  </button>
                </div>
              </div>
            </div>
          </form>
        )}
        <div className="searchBarResults py-0 ps" id="searchBarResults">
          <div className="list-group hidden" id="searchResults" />
          <div className="ps__rail-x" style={{ left: 0, bottom: 0 }}>
            <div
              className="ps__thumb-x"
              tabIndex={0}
              style={{ left: 0, width: 0 }}
            />
          </div>
          <div className="ps__rail-y" style={{ top: 0, right: 0 }}>
            <div
              className="ps__thumb-y"
              tabIndex={0}
              style={{ top: 0, height: 0 }}
            />
          </div>
        </div>
      </div>

      {currentRoute === "/test" ? (
        <section className="content-header">
          <div
            className="header-container"
            style={{
              padding: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between", // Space between content and SVG
              backgroundColor: "#f5f5f5",
              borderRadius: "8px",
              marginBottom: "13px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <UserOutlined
                style={{
                  fontSize: "32px",
                  marginRight: "15px",
                  color: "#1890ff",
                }}
              />
              <div>
                <h2 style={{ margin: 0, fontWeight: "bold" }}>
                  Welcome,{" "}
                  <span style={{ color: "#4a90e2" }}>{user?.name}</span>
                </h2>
                <p style={{ margin: 0, color: "#777" }}>
                  You have 2 pending tasks
                </p>
              </div>
            </div>
            {/* SVG Image */}
            {/* <div>
            <img
              src="/dist/img/draw.svg"
              alt="Header SVG"
              style={{ height: "60px", width: "auto" }}
            />
          </div>

          <div>
            <img
              src="/dist/img/draw3.svg"
              alt="Header SVG"
              style={{ height: "60px", width: "auto" }}
            />
          </div>
          <div>
            <img
              src="/dist/img/draw2.svg"
              alt="Header SVG"
              style={{ height: "60px", width: "auto" }}
            />
          </div> */}
          </div>
        </section>
      ) : (
        <section className="content-header"></section>
      )}

      <section
        className="content"
        textAlign="left"
        style={{
          height: "100vh",

          backgroundImage: `
         radial-gradient(rgba(0, 0, 0, 0.2) 1px, transparent 1px),
          radial-gradient(rgba(0, 0, 0, 0.2) 1px, transparent 1px)
      `,
          backgroundPosition: "0 0, 25px 25px", // Adjust spacing between dots
          backgroundSize: "50px 50px", // Adjust size of the grid
          padding: "0 10px",
        }}
      >
        <Routes>
          <Route
            path="/"
            element={
              user?.role === "Administrator" ? (
                <Home />
              ) : (
                <Navigate to="/all-loans" replace />
              )
            }
          />
          <Route
            path="/dashboard"
            element={
              user?.role === "Administrator" ? (
                <Home />
              ) : (
                <Navigate to="/all-loans" replace />
              )
            }
          />
          <Route path="/home" element={<Navigate to="/dashboard" replace />} />
          <Route path="/users" element={<Users />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/borrowers" element={<Borrowers />} />
          <Route path="/borrower/:id" element={<Borrower />} />
          <Route path="/addLoan" element={<AddLoan />} />
          <Route path="/addGovtLoan" element={<AddGovtLoan />} />
          <Route path="/collateral" element={<CollateralRegister />} />
          <Route path="/loans/:status" element={<LoansPage />} />
          <Route path="/all-loans" element={<LoansDisbursedPage />} />
          <Route path="/amortizations" element={<JutemLoansPage />} />
          <Route path="/expenses" element={<JutemExpensesPage />} />
          <Route path="/jutem-investments" element={<JutemInvestmentsPage />} />
          <Route path="/interest-expenses" element={<JutemInterestExpensesPage />} />
          <Route path="/income-statement" element={<JutemIncomeStatement />} />
          <Route path="/jutem-upload" element={<JutemEtlUploadPage />} />
          <Route path="/jutem-ledger" element={<JutemLedgerPage />} />
          <Route path="/loans-outstanding" element={<LoansOutstandingPage />} />
          <Route path="/loan/:id" element={<LoanDetailsPage />} />
          <Route path="/loan/edit/:loanId" element={<EditLoan />} />
          <Route path="/updateLoanStatus/:id" element={<UpdateLoanStatus />} />
          <Route path="/portfolio" element={<LoanPortfolioSummary />} />
          <Route path="/addBorrower" element={<AddBorrower />} />
          <Route path="/loanProducts" element={<LoanProductsPage />} />
          <Route path="/investmentProducts" element={<InvestmentProducts />} />
          <Route path="/deliquency_report" element={<DelinquencyReport />} />
          <Route path="/transactions" element={<TransactionsPage />} />
          <Route path="/floatManagement" element={<FloatManagementPage />} />
          <Route
            path="/riskConcentration"
            element={<RiskConcentrationReport />}
          />
          <Route path="/paymentPromises" element={<PtpPage />} />
          <Route path="/cashflow" element={<CashFlowForecast />} />
          <Route path="/profitability" element={<ProfitabilityAnalysis />} />
          <Route
            path="/applicationPipeline"
            element={<ApplicationPipelineReport />}
          />
          <Route path="/documents" element={<DocumentsPage />} />
          <Route path="/nrc-verification" element={<NrcVerificationPage />} />
          <Route
            path="/nrc-verification/:id"
            element={<NrcVerificationPage />}
          />
          <Route path="/collateralReport" element={<CollateralReport />} />
          <Route
            path="/officerPerformance"
            element={<LoanOfficerPerformanceReport />}
          />
          <Route path="/collateral/:id" element={<CollateralProfile />} />
          <Route path="/investment/:id" element={<InvestmentDetailsPage />} />
          <Route path="/bulksms" element={<BulkSMSPage />} />
          <Route path="/whatsapp" element={<WhatsAppPage />} />
          <Route path="/billing" element={<Billing />} />
          <Route path="/contact-to-upgrade" element={<ContactToUpgrade />} />
          <Route path="/investors" element={<Investors />} />
          <Route path="/planCheckout/:tier" element={<PlanCheckout />} />
          <Route path="/maturityReport" element={<InvestmentsPage />} />
          <Route path="/giftcards" element={<Giftcards />} />
          <Route path="/trackers" element={<GpsTrackers />} />
          <Route path="/issues" element={<IssuesPage />} />
          <Route path="/branches" element={<Branches />} />
          <Route path="/commodities" element={<Commodities />} />
          <Route path="/accountsManagement" element={<AccountsManagement />} />
          <Route path="/assets" element={<AssetsManagement />} />
          <Route path="/invoices" element={<InvoicesPage />} />
          <Route path="/boarding_houses" element={<BoardingHouses />} />
          <Route path="/demo-bookings" element={<DemoBookings />} />
          <Route path="/due-today" element={<DueTodayDashboard />} />
          <Route path="/today-summary" element={<TodaySummary />} />
          <Route path="/roles" element={<RoleManagement />} />
          <Route path="/sales" element={<CollateralSales />} />
          <Route path="/discussion-forum" element={<DiscussionForum />} />
          <Route path="/calendar" element={<CalendarPage />} />
          <Route path="/verify" element={<VehicleVerification />} />
          <Route path="/rider-tracking" element={<RiderTracking />} />
          <Route path="/deliveries" element={<DeliveriesPage />} />
          <Route path="/expense-approvals" element={<ExpenseApprovalsPage />} />
          <Route path="/test-pdf" element={<TestPDFGeneration />} />
          <Route
            path="/business-quotation"
            element={<BusinessQuotationPage />}
          />
          <Route path="/debt-age-analysis" element={<DebtAgeAnalysis />} />
          <Route path="/income-statement" element={<IncomeStatement />} />
          <Route path="/account-statement" element={<AccountStatement />} />
          <Route path="/trial-balance" element={<TrialBalance />} />
          <Route
            path="/double-entry-balance-sheet"
            element={<DoubleEntryBalanceSheet />}
          />
          <Route path="/general-ledger" element={<GeneralLedger />} />
          <Route
            path="/accounting-migration"
            element={<AccountingMigration />}
          />
        </Routes>
      </section>
    </div>
  );
};

export default Content;
